exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.handing-all-btn[data-v-e6f3e36e]{\n  margin-left:20px;\n  margin-top:20px;\n}\n.handing-table[data-v-e6f3e36e]{\n  margin-top: 40px;\n}\n.handing-pagination[data-v-e6f3e36e]{\n  margin-top:40px;\n  height: 40px;\n  text-align: center;\n}\n", ""]);

// exports
